import _ from "lodash";
import Reflux from "reflux";
import Freezer from "freezer-js";
import DataTrackingOptions from "../react_actions/data_tracking/data_tracking_actions";
import ClickTrackingActions from "../react_actions/click_tracking_actions";

const defaultState = { pmetClickTrackUrl: "https://www.goodreads.com/track" };
const state = new Freezer(defaultState);

const resetTo = (data={}) => {
  getState().reset(_.merge({}, defaultState, data));
};

const getState = () => state.get();

export default Reflux.createStore({

  listenables: [ClickTrackingActions, { trackClickEvent: DataTrackingOptions.trackClickEvent }],

  initializeWith(data) {
    resetTo(data);
  },

  updateWith(data) {
    getState().set(_.merge({}, getState(), data));
  },

  onTrackClickEvent(event, source) {
    let target = event.target;
    let pmet, pmetData;

    //crawl up the source tree until you find the dfp and pmet tracking data
    while (target !== source) {
      if (target.getAttribute("data-tracking-pmet") && !pmet) {
        pmet = target.getAttribute("data-tracking-pmet");
        pmetData = JSON.parse(pmet);
        this.trackPmetClick(pmetData);
      }
      target = target.parentNode;
    }
  },

  mergeWith(data) {
    getState().set(_.merge({}, getState(), data));
  },

  trackPmetClick(additionalParams) {
    $j.ajax({
      type: "GET",
      url: getState().pmetClickTrackUrl,
      data: additionalParams,
    });
  },

  getInitialState() {
    return getState();
  },

  getState,

  reset:resetTo,

  notifyListeners() {
    this.trigger(getState());
  },

});
